import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { TipoMarcacaoEnum } from '../../../enums/tipo-marcacao-enum';

@Component({
  selector: 'app-agendamento-paciente-list',
  templateUrl: './agendamento-paciente-list.component.html',
  styleUrls: ['./agendamento-paciente-list.component.css']
})
export class AgendamentoPacienteListComponent extends AbstractCrudComponent implements OnInit {

  displayedColumns: string[] = ['dataMarcacao', 'horaAtendimento', 'nomePaciente', 'nomePacienteTitular',
    'nomeFilial', 'nomeProcedimento', 'nomeProcedimentoConsulta', 'nomeMedico', 'dilataPupila'];

  constructor(router: Router, dialog: MatDialog) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();

    this.configureTableColumns(window.innerWidth);
  }

  reloadData() {
    if (history.state.agendamentos) {
      this.data = history.state.agendamentos;
    } else {
      this.data = [];
    }
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        pacienteTitular: history.state.pacienteTitular,
        tipoMarcacao: history.state.tipoMarcacao,
        agendamentos: history.state.agendamentos
      }
    });
  }

  onResize(event: any) {

    super.onResize(event);

    this.configureTableColumns(event.target.innerWidth);
  }

  configureTableColumns(innerWidth: any): void {


    if (history.state.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {

      if (innerWidth > 630) {
        this.displayedColumns = ['dataMarcacao', 'horaAtendimento', 'nomePaciente', 'nomePacienteTitular',
          'nomeFilial', 'nomeProcedimento', 'nomeMedico', 'dilataPupila'];
      } else {
        this.displayedColumns = ['dataMarcacao', 'horaAtendimento', 'nomePaciente', 'nomeFilial',
          'nomeProcedimento', 'nomeMedico'];
      }

    } else if (history.state.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {

      if (innerWidth > 630) {
        this.displayedColumns = ['dataMarcacao', 'horaAtendimento', 'nomePaciente', 'nomePacienteTitular',
          'nomeFilial', 'nomeProcedimentoConsulta', 'nomeMedico'];
      } else {
        this.displayedColumns = ['dataMarcacao', 'horaAtendimento', 'nomePaciente', 'nomeFilial',
          'nomeProcedimentoConsulta', 'nomeMedico'];
      }

    }
  }
}
